import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "collapse-icon ml-4 cursor-pointer rotate-180" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/login-logo.png",
  height: "32"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EnIconVue = _resolveComponent("EnIconVue")!
  const _component_CnIconVue = _resolveComponent("CnIconVue")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style['mobile-layout-header'])
  }, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_a_button, {
      type: "link",
      size: "small",
      class: _normalizeClass(_ctx.$style['mobile-layout_language']),
      onClick: _ctx.toggleLanguage
    }, {
      default: _withCtx(() => [
        (_ctx.isEnChange)
          ? (_openBlock(), _createBlock(_component_EnIconVue, { key: 0 }))
          : (_openBlock(), _createBlock(_component_CnIconVue, { key: 1 }))
      ]),
      _: 1
    }, 8, ["class", "onClick"])
  ], 2))
}